import { Lock2Line } from '@datanomik/core-ui/icons';
import type { ComponentProps } from 'react';

type BankIntegrationCredentialIconProps = ComponentProps<typeof Lock2Line>;

export const BankIntegrationCredentialIcon = (props: BankIntegrationCredentialIconProps) => (
  <Lock2Line {...props} />
);
